import { getOfficeNameFromCurrentHref } from "@/utils/getParamsFromPath";

const postFix = " | xtur 3.0";

export const titleMixin = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  created() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof this.windowTitle !== "undefined") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      let title = this.windowTitle;
      if (typeof title === "function") {
        title = title(this);
      }
      const officeShortName = getOfficeNameFromCurrentHref();
      if (officeShortName != "") {
        document.title = officeShortName + " | " + title + postFix;
      } else {
        document.title = title + postFix;
      }
    }
  },
  watch: {
    windowTitle(): void {
      if (typeof this.windowTitle !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let title = this.windowTitle;
        if (typeof title === "function") {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          title = title(this);
        }
        const officeShortName = getOfficeNameFromCurrentHref();
        if (officeShortName != "") document.title = officeShortName + " | " + title + postFix;
        document.title = title + postFix;
      }
    },
  },
};
